module.exports = __webpack_public_path__ + "static/img/2_6_1.cad75639.jpg";